<template>
  <span :class="{ red: exceed }">
    <span v-if="unit">¥</span>
    <span>{{ amount }}</span>
  </span>
</template>

<script>
import { formatCurrency } from '@/utils/chineseNum.js'
export default {
  props: {
    num: Number,
    decimal: {
      type: Number,
      default: 2
    },
    unit: {
      type: String,
      default: '¥'
    },
    cap: {
      type: Number,
      default: 500
    }
  },
  computed: {
    amount() {
      return formatCurrency(this.num, this.decimal)
    },
    exceed() {
      return this.num >= this.cap
    }
  }
}
</script>

<style scoped>
.red {
  color: red;
}
</style>